import Vue from 'vue';
import Vuex from 'vuex';

import asset_status from "./asset_status/asset_status.module";
import asset_type from "./asset_type/asset_type.module";
import country from "./country/country.module";
import courseType from "./course_type/course_type.module";
import currency from "./currency/currency.module";
import ecsCompany from "./ecs_company/ecs_company.module";
import employmentType from "./employment_type/employment_type.module";
import job from "./job/job.module";
import person from "./person/person.module";
import person_address from "./person_address/person_address.module.ts";
import person_asset from "./person_asset/person_asset.module.ts";
import person_availability from "./person_availability/person_availability.module.ts";
import person_course from "./person_course/person_course.module.ts";
import person_emergency_contact from "./person_emergency_contact/person_emergency_contact.module.ts";
import person_employment from "./person_employment/person_employment.module.ts";
import person_holiday_entitlement from "./person_holiday_entitlement/person_holiday_entitlement.module.ts";
import person_phone_number from "./person_phone_number/person_phone_number.module.js";
import person_team from "./person_team/person_team.module.ts";
import person_vehicle from "./person_vehicle/person_vehicle.module.ts";
import personnel_country from "./personnel_country/personnel_country.module.ts";
import team from "./team/team.module";
import thisApp from "./this_app/this_app.module";
import user from "./user/user.module";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
        asset_type,
        country,
        ecsCompany,
        employmentType,
        job,
        person,
        person_address,
        person_asset,
        person_course,
        person_emergency_contact,
        person_employment,
        person_holiday_entitlement,
        person_phone_number,
        person_team,
        person_vehicle,
        personnel_country,
        team,
        thisApp,
        user,
        asset_status,
        person_availability,
        currency,
        courseType
    }
});

